import React from "react";
import { useRound } from "context/roundContext";
import { useLeague } from "context/leagueContext";
import SkeletonLoader from "components/skeletonLoader";
import Info from "components/info";
import { useTranslation } from "react-i18next";
import RoundEvents from "views/userLeague/rounds/roundContent/eventList";
import RoundResults from "views/userLeague/rounds/roundContent/results";
import RoundLeaderboard from "views/userLeague/rounds/roundContent/leaderboard";
import RoundStatus from "views/userLeague/rounds/roundContent/status";
import { useRoundData } from "hooks/useRoundData";
import PayoutChart from "./payoutChart";
import KnockoutLeaderboard from "./knockoutLeaderboard";

import LmsTabs from "./lmsTabs";

const Round = ({ roundData }) => {
  const {
    state: { leagueInfo, leagueUserData, nextRoundId },
  } = useLeague();
  const {
    state: { isLoading, userRoundData, currentRound },
  } = useRound();
  const { t } = useTranslation();
  useRoundData(roundData.id);

  let roundStarted = new Date(roundData?.deadline?.seconds * 1000) < new Date();

  let deadline = new Date(roundData?.deadline?.seconds * 1000).toLocaleString(
    undefined,
    {
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      hour12: false,
      minute: "2-digit",
    }
  );

  if (isLoading) {
    return <SkeletonLoader type={"eventCard2"} amount={3} />;
  }

  return (
    <>
      {leagueInfo?.gameRule == 2 && <RoundStatus />}

      <div className="flex sticky top-1 mb-2 items-center justify-center w-full space-x-2 z-10">
        {(((leagueInfo?.scoreRule == 6 || leagueInfo?.scoreRule == 8) &&
          !roundStarted) ||
          leagueInfo?.scoreRule == 4) && (
          <Info
            count={
              leagueInfo?.scoreRule == 6
                ? leagueUserData?.leaguePicks
                : userRoundData?.roundPicks
            }
            label={
              leagueInfo?.scoreRule == 6
                ? t("tournament.info_container.leaguePick", {
                    count: leagueUserData?.leaguePicks,
                  })
                : t("tournament.info_container.roundPick", {
                    count: userRoundData?.roundPicks,
                  })
            }
            infoType={leagueInfo?.scoreRule == 6 ? "leaguePicks" : "roundPicks"}
          />
        )}

        {(leagueInfo?.scoreRule == 6 || leagueInfo?.scoreRule == 8) && (
          <Info
            label={
              roundStarted
                ? t("tournament.info_container.deadline_passed")
                : t("tournament.info_container.deadline") + ": " + deadline
            }
            infoType={"deadline"}
          />
        )}
        {(leagueInfo?.gameRule == 0 || leagueInfo?.scoreRule == 1) &&
          leagueUserData?.boosts > 0 && (
            <Info
              count={leagueUserData?.boosts}
              label={t("tournament.info_container.boost", {
                count: leagueUserData?.boosts,
              })}
              infoType={"boosts"}
            />
          )}
      </div>

      {leagueInfo?.scoreRule == 5 ? (
        <LmsTabs />
      ) : (
        <RoundEvents key={roundData.id} />
      )}

      {leagueInfo?.gameType == 0 && leagueInfo?.scoreRule != 8 && (
        <>
          <RoundResults />
          <RoundLeaderboard />
        </>
      )}
      {leagueInfo?.gameRule == 4 &&
        leagueInfo?.scoreRule == 1 &&
        (roundData?.settled || roundData?.id == nextRoundId) && (
          <>
            <KnockoutLeaderboard />
          </>
        )}
      {(leagueInfo?.scoreRule == 6 ||
        leagueInfo?.scoreRule == 8 ||
        (leagueInfo?.gameRule == 4 && leagueInfo?.scoreRule == 0)) && (
        <>
          <PayoutChart />
        </>
      )}
    </>
  );
};

export default Round;
